import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sortable-header',
  standalone: false,
  template: `
    <span class="sortable-header" (click)="onSort()">
      <ng-content></ng-content>
      <span class="sort-icons">
        <span class="sort-arrow up" [class.active]="currentSortField === field && currentSortOrder === 1"></span>
        <span class="sort-arrow down" [class.active]="currentSortField === field && currentSortOrder === -1"></span>
      </span>
    </span>
  `,
  styles: [`
    .sort-icons { display: inline-flex; flex-direction: column; margin-left: 4px; gap: 1px; vertical-align: middle; }
    .sort-arrow { width: 0; height: 0; border-left: 4px solid transparent; border-right: 4px solid transparent; }
    .sort-arrow.up { border-bottom: 5px solid #ccc; }
    .sort-arrow.down { border-top: 5px solid #ccc; }
    .sort-arrow.up.active { border-bottom-color: #ea5b0c; }
    .sort-arrow.down.active { border-top-color: #ea5b0c; }
  `]
})
export class SortableHeaderComponent {
  @Input() field = '';
  @Input() currentSortField = '';
  @Input() currentSortOrder = 0;

  @Output() sortChange = new EventEmitter<{ field: string; order: number }>();

  get isAsc(): boolean {
    return this.currentSortField === this.field && this.currentSortOrder === 1;
  }

  get isDesc(): boolean {
    return this.currentSortField === this.field && this.currentSortOrder === -1;
  }

  onSort(): void {
    let order: number;
    if (this.currentSortField === this.field) {
      order = this.currentSortOrder === 1 ? -1 : 1;
    } else {
      order = 1;
    }
    this.sortChange.emit({ field: this.field, order });
  }
}
